<template>
  <div class="app-container">
    <div class="filter-container">
      <el-input
        v-model="listQuery.keyword"
        placeholder="请输入关键字"
        style="width: 200px"
        class="filter-item"
        clearable
      />
      <el-input
        v-model="listQuery.userId"
        placeholder="用户编号"
        style="width: 200px"
        class="filter-item"
        clearable
      />
      <el-select
        v-model="listQuery.status"
        placeholder="状态"
        style="width: 120px"
        class="filter-item"
        clearable
      >
        <el-option
          v-for="item in EXCHANGE_VOUCHER_STATUS"
          :key="item.key"
          :label="item.value"
          :value="item.key"
        />
      </el-select>
      <DataPicker
        @valueFunc="getPickerValueFunc"
        paramsType="apply"
        startPlaceholder="兑换开始时间"
        endPlaceholder="兑换截止时间"
      />
      <el-button
        class="filter-item"
        type="primary"
        icon="el-icon-search"
        @click="handleFilter"
        style="margin-left: 10px"
        >搜索</el-button
      >
    </div>

    <div style="margin-bottom: 5px">交易所兑换单数量:{{ total }}</div>

    <el-table
      v-loading="listLoading"
      :data="list"
      element-loading-text="Loading"
      size="small"
      border
      fit
      highlight-current-row
    >
      <el-table-column align="center" prop="id" label="ID" width="95"></el-table-column>
      <el-table-column label="用户编号" align="center" prop="userId" width="100"></el-table-column>
      <el-table-column
        label="用户姓名"
        align="center"
        prop="userName"
        width="100"
      ></el-table-column>
      <el-table-column
        label="用户手机号码"
        align="center"
        prop="userMobile"
        width="100"
      ></el-table-column>
      <el-table-column label="交易编号" align="center" prop="tradeNo" width="240"></el-table-column>
      <el-table-column
        label="交易所订单号"
        align="center"
        prop="exchNo"
        width="240"
      ></el-table-column>
      <el-table-column label="交易所名称" align="center" prop="name" width="120"></el-table-column>
      <el-table-column label="账户类别" align="center" prop="category">
        <template slot-scope="scope">
          {{ getValue(ACCOUNT_CATEGORY, scope.row.category) }}
        </template>
      </el-table-column>
      <el-table-column label="账户类型" align="center" prop="type">
        <template slot-scope="scope">
          {{ getValue(ACCOUNT_TYPE, scope.row.type) }}
        </template>
      </el-table-column>
      <!-- <el-table-column label="方向" align="center" prop="direction" width="100">
        <template slot-scope="scope">
          {{ getValue(EXCHANGE_VOUCHER_DIRECTION, scope.row.direction) }}
        </template>
      </el-table-column> -->
      <el-table-column class-name="status-col" label="状态" align="center" width="100">
        <template slot-scope="scope">
          {{ getValue(EXCHANGE_VOUCHER_STATUS, scope.row.status) }}
        </template>
      </el-table-column>
      <el-table-column label="兑换数量" align="center" prop="amount"></el-table-column>
      <el-table-column label="手续费数量" align="center" prop="rate" width="180">
        <template slot-scope="scope">
          <span>{{ scope.row.feeAmount }}</span>
        </template>
      </el-table-column>
      <el-table-column label="入账数量" align="center" prop="inAmount"></el-table-column>
      <el-table-column align="center" prop="ctdate" label="兑换的币种代码" width="180">
        <template slot-scope="scope">
          <span>{{ scope.row.coinCode }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="ctdate" label="备注" width="180">
        <template slot-scope="scope">
          <span>{{ scope.row.remark }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="ctdate" label="兑换时间" width="180">
        <template slot-scope="scope">
          <i class="el-icon-time" />
          <span>{{ formatApiDate(scope.row.ctdate) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        align="center"
        width="200"
        fixed="right"
        class-name="small-padding fixed-width"
      >
        <template slot-scope="scope">
          <el-button
            v-if="scope.row.status == 4"
            type="primary"
            size="mini"
            @click="onC(scope.row, 1)"
            >同意</el-button
          >

          <el-button
            v-if="scope.row.status == 4"
            type="error"
            size="mini"
            @click="onC(scope.row, 2)"
            >拒绝</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-container">
      <el-pagination
        :current-page="listQuery.page"
        :page-sizes="[10, 20, 30, 50, 100]"
        :page-size="listQuery.pageSize"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>

<script>
import { getExchtradeList, reviewWithdrawTbc } from "@/api/finance";
import { formatApiDate } from "@/utils/utils";
import {
  getValue,
  EXCHANGE_VOUCHER_STATUS,
  ACCOUNT_CATEGORY,
  ACCOUNT_TYPE,
  EXCHANGE_VOUCHER_DIRECTION
} from "@/utils/enumUtile";
import DataPicker from "@/views/components/dataPicker";

export default {
  computed: {
    formatApiDate() {
      return formatApiDate;
    },
    EXCHANGE_VOUCHER_STATUS() {
      return EXCHANGE_VOUCHER_STATUS;
    },
    ACCOUNT_CATEGORY() {
      return ACCOUNT_CATEGORY;
    },
    ACCOUNT_TYPE() {
      return ACCOUNT_TYPE;
    },
    EXCHANGE_VOUCHER_DIRECTION() {
      return EXCHANGE_VOUCHER_DIRECTION;
    }
  },
  components: { DataPicker },
  filters: {},
  data() {
    return {
      list: null,
      total: 0,
      listLoading: false,
      listQuery: {
        page: 1,
        pageSize: 20,
        keyword: null,
        userId: null,
        status: null,
        applyStartTime: null, //申请开始时间
        applyEndTime: null //申请截止时间
      }
    };
  },
  created() {
    this.getList();
  },
  watch: {},
  methods: {
    onC(row, type) {
      let text = "";
      if (type == 1) {
        text = "是否同意, 是否继续?";
      } else {
        text = "是否同意, 是否继续?";
      }
      this.$confirm(text, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          let params = {
            id: row.id,
            status: type
          };
          this.listLoading = true;
          reviewWithdrawTbc(params)
            .then(res => {
              if (res.bizcode == 100) {
                this.$message({
                  type: "success",
                  message: "操作成功"
                });
                this.getList();
              }
            })
            .finally(() => {
              this.listLoading = false;
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消"
          });
        });
    },
    getValue,
    handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    handleSizeChange(val) {
      this.listQuery.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    /**
     * 查询列表
     */
    getList() {
      this.listLoading = true;
      const form = this.listQuery;
      const params = {
        ...form
      };
      getExchtradeList(params)
        .then(response => {
          this.list = response.data.entitys;
          this.total = response.data.totalCount;
        })
        .finally(() => {
          this.listLoading = false;
        });
    },

    /**
     * 获取时间
     * @param type
     * @param value
     */
    getPickerValueFunc(type, value) {
      if (type === "apply") {
        this.listQuery.applyStartTime = value[0];
        this.listQuery.applyEndTime = value[1];
      }
    }
  }
};
</script>
<style scoped lang="scss">
.el-dropdown-link {
  cursor: pointer;
  margin-left: 10px;
}
.comm_but_warp {
  margin-bottom: 10px;
}
</style>
